import React, { useState } from 'react';
import { Link } from "react-router-dom";
import { space6, BWHeader } from "../dist/helpers"

import ArrowController from "./ArrowController";

// Cache natural frame sizes keyed by image URL + grid dimensions
const frameSizeCache = {};

const TakePart = ({ image, part1, part2, multiplier = 1, cols = 4, rows = 4 }) => {
  const cacheKey = `${image}:${cols}x${rows}`;
  const cached = frameSizeCache[cacheKey];
  const [frameW, setFrameW] = useState(cached?.w ?? 64);
  const [frameH, setFrameH] = useState(cached?.h ?? 64);

  const handleLoad = (e) => {
    const w = e.target.naturalWidth / cols;
    const h = e.target.naturalHeight / rows;
    frameSizeCache[cacheKey] = { w, h };
    setFrameW(w);
    setFrameH(h);
  };

  return (
    <div style={{
      width: `${multiplier * frameW}px`,
      height: `${multiplier * frameH}px`,
      overflow: 'hidden',
      display: 'inline-block',
    }}>
      <img
        alt=""
        src={image}
        onLoad={handleLoad}
        style={{
          margin: `-${multiplier * frameH * part1}px 0px 0px -${multiplier * frameW * part2}px`,
        }}
      />
    </div>
  );
};

export const SpriteFourStep = (frame, image, offset = 0, offset2 = 0, multiplier=1) =>
  <TakePart image={image} part1={offset2} part2={frame + offset} multiplier={multiplier} />;

// Renders a single specific cell from a sprite sheet by (row, col) index
export const SpriteFrame = (image, row, col, multiplier=1, cols=4, rows=4) =>
  <TakePart image={image} part1={row} part2={col} multiplier={multiplier} cols={cols} rows={rows} />;

export const SpriteTwoStep = (frame, image, offset = 0, offset2 = 0, multiplier=1) =>
  <TakePart image={image} part1={offset2} part2={(frame > 0 ? 0 : 1) + offset} multiplier={multiplier} />;

export default function Experimental(props) {
  const { dark } = props;

  return (
    <div>
      <center>
        { BWHeader(dark, "Experimental", "This is the work in progress kinda stuff") }
        { space6 }

        <Link to="/xpComponent" style={{ paddingRight: "1rem" }}>
          <button className="btn btn-light" type="button" style={{ marginTop: "1rem" }}>
            Checkout XPComponent!
          </button>
        </Link>

        <Link to="/Win98theme" style={{ paddingRight: "1rem" }}>
          <button className="btn btn-light" type="button" style={{ marginTop: "1rem" }}>
            Checkout Win98theme!
          </button>
        </Link>
        { space6 }

        <ArrowController />

      </center>
    </div>
  )
};
